import React from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PeopleIcon from "@mui/icons-material/GroupAdd";
import AddCircleIcon from "@mui/icons-material/Add";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";

import OrganizationRaw from "./OrganizationRaw";
import { UserProfileCard } from "shared/dist/components";

import { userActions } from "../../../Services/Redux/actionCreators";
import { GlobalRoutes } from "../../../GlobalRouter/Routes";
import { rejectedStatuses } from "../../../Utils/organizationSetup";
import { resetOrganizationDetailsData } from "../../../Services/Redux/actionCreators/organizationActions";
import classes from "./UserPopUp.module.css";
import { useNavigateTo } from "../../../GlobalRouter/hook/NavigateTo";
import useActionAfterDialogClose from "../../../Hooks/useActionAfterDialogClose";

const UserProfilePopUp = ({ show, handleClose, headerType }) => {
    const { nickname, orgList, orgUuid } = useSelector(
        (state) => ({
            nickname: state.user.nickname,
            orgList: state.organization.organizationsList,
            orgUuid: state.organization.uuid,
        }),
        shallowEqual
    );
    const dispatch = useDispatch();
    const navigateTo = useNavigateTo();
    const { closeAndRun } = useActionAfterDialogClose({ isOpen: show, onClose: handleClose });

    const handleSignout = () => {
        closeAndRun(async () => {
            await dispatch(userActions.loginActions.signout);
            navigateTo.overview(GlobalRoutes.OVERVIEW.path);
        });
    };

    const handleTeamMembers = () => {
        closeAndRun(() => navigateTo.inviteMembers({ orgUuid }));
    };

    const handleCreateOrganization = () => {
        closeAndRun(() => {
            dispatch(resetOrganizationDetailsData());
            navigateTo.onboarding();
        });
    };

    const isOrganizationDisplay = (organization) => {
        return organization.uuid && !rejectedStatuses.includes(organization.state.state);
    };

    return (
        <Modal open={show} onClose={handleClose} disableAutoFocus>
            <div
                className={`${classes.UserProfilePopUpContainer} ${headerType === "mobile" ? classes.mobUserProPopup : null}`}
                onClick={(event) => event.stopPropagation()}
            >
                <UserProfileCard nickName={nickname} />
                <ul className={classes.userProfileMenuList}>
                    <li className={classes.teamListItem} onClick={handleTeamMembers}>
                        <span className={classes.title}>Team</span>
                        <PeopleIcon />
                    </li>
                    <li className={classes.teamListItem}>
                        <span className={classes.title}>Organizations</span>
                        <IconButton onClick={handleCreateOrganization}>
                            <AddCircleIcon />
                        </IconButton>
                    </li>
                    {orgList.map(
                        (organization) =>
                            isOrganizationDisplay(organization) && (
                                <li key={organization.uuid + organization.owner.username}>
                                    <OrganizationRaw
                                        orgUuid={organization.uuid}
                                        orgImg={organization.assets.heroImage.url}
                                        orgName={organization.name}
                                        orgStatus={organization.state.state}
                                        orgOwner={organization.owner.username}
                                        closeAndRun={closeAndRun}
                                    />
                                </li>
                            )
                    )}
                    <li className={classes.signoutLink} onClick={handleSignout}>
                        <ExitToAppIcon />
                        <span>Sign Out</span>
                    </li>
                </ul>
            </div>
        </Modal>
    );
};

export default UserProfilePopUp;
